import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { ApiService } from '../../shared/services';
import { VendorClientAssignment } from '../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendorClientAssignmentService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  getVendorClientAssignment(searchParam:IGlobalSearchParam):Observable<any>{
      return this.apiService.post(`VendorClientAssignment/SearchVendorClientAssignment`,searchParam)
  }

  deleteVcaDetail(id:number):Observable<any> {
    return this.apiService.delete(`VendorClientAssignment/${id}`)
  }

  getVendorCompanyList():Observable<any>{
    // return this.apiService.get(`CompanyProfile/AllApprovedCompanyList`);
    return this.apiService.get(`CompanyProfile/VendorCompanyList`);
  }

  getRequisitionInvoiceOnlyVendorCompanyList():Observable<any>{
    return this.apiService.get(`CompanyProfile/RequisitionInvoiceOnlyVendorCompanyList`);
  }

  getInvoiceOnlyVendorCompanyList():Observable<any>{
    return this.apiService.get(`CompanyProfile/InvoiceOnlyVendorCompanyList`);
  }

  getClientsNotAssignmentForVendorCompany(companyId: number):Observable<any>{
    return this.apiService.get(`VendorClientAssignment/ClientsNotAssignmentForVendorCompany/${companyId}`)
  }

  postVendorClientAssignment(vendorClientAssignment: VendorClientAssignment): Observable<any> {
    return this.apiService.post(`VendorClientAssignment/AddVendorClientAssignment`, vendorClientAssignment)
  }

  public ExportVendorClientAssignment(searchParam:IGlobalSearchParam):Observable<any> {
    return this.http.post(`${environment.apiRoot}VendorClientAssignment/ExportVendorClientAssignment`, searchParam,
    {  
        responseType: 'blob',
        observe: 'response'
     });
  }
  public UpdateVendorClientAssignmentStatus(value:VendorClientAssignment):Observable<any>{
    return this.apiService.post(`VendorClientAssignment/UpdateVendorClientAssignmentStatus`,value);
  }
}
